import { FetchUtil } from "../util/FetchUtil";
import { IMyCmeModel } from "../models/MyCme/IMyCmeModel";
import { IMyHealioCmeModel } from "../models/MyCme/IMyHealioCmeModel";
import { StringUtil } from "../util/StringUtil";
import { WyanokeUtil } from "../util/WyanokeUtil";
import { IMyHealioCmeEndpoint } from "../models/MyCme/IMyHealioCmeEndpoint";

interface IMyCmeResponse {
  readonly completed?: number;
  readonly inprogress?: number;
  readonly totalcredits?: number;
  readonly creditbreakdown?: ReadonlyArray<{
    readonly credittype?: string;
    readonly credits?: number;
  }>;
}

export class MyCmeService {
  private _currentMyCmePromise: Promise<IMyCmeModel | null> | null = null;
  private _currentMyHealioCmePromise: Promise<IMyHealioCmeModel | null> | null = null;

  constructor(private readonly _endpoint: IMyHealioCmeEndpoint) {
  }

  public async getMyCmeJson(): Promise<IMyHealioCmeModel | null> {
    const cachedPromise = this._currentMyHealioCmePromise;

    return cachedPromise ?
      cachedPromise :
      this._currentMyHealioCmePromise = this.jsonLoad();
  }

  private async jsonLoad(): Promise<IMyHealioCmeModel | null> {
    const endpoint = this._endpoint;
    if (!endpoint) {
      throw new Error("Could not resolve endpoint.");
    }

    const profile = await WyanokeUtil.loadUserProfile(true, false);
    if (!profile) {
      return null;
    }

    const contactId = profile.contactid || "";

    if (!endpoint.jsonLoad?.url || !endpoint.jsonLoad.method) {
      throw new Error("Could not resolve load endpoint URL.");
    }

    let raw;
    let msg = "";
    try {
      raw = await FetchUtil.sendMessage(endpoint.jsonLoad, { contactid: contactId });
    } catch (err) {
      if (err) {
        const error = err as Error;
        console.error(error.message);
      }
    }

    if (msg.length > 0) {
      console.error(msg);
      throw new Error(msg);
    }

    const response = raw as IMyHealioCmeModel;

    return response;
  }


  public async getMyCme(): Promise<IMyCmeModel | null> {
    const cachedPromise = this._currentMyCmePromise;

    return cachedPromise ?
      cachedPromise :
      this._currentMyCmePromise = this.load();
  }

  private async load(): Promise<IMyCmeModel | null> {
    const endpoint = this._endpoint;
    if (!endpoint) {
      throw new Error("Could not resolve endpoint.");
    }

    const profile = await WyanokeUtil.loadUserProfile(true, false);
    if (!profile) {
      return null;
    }

    const contactId = profile.contactid || "";
    const values = {
      contactId,
      encodedContactId: encodeURIComponent(contactId)
    };

    if (!endpoint.load?.url || !endpoint.load.method) {
      throw new Error("Could not resolve load endpoint URL.");
    }
    const url = StringUtil.supplant(endpoint.load.url, values) || "";

    let raw;
    let msg = "";
    try {
      raw = await FetchUtil.sendMessage({
        method: endpoint.load.method,
        url
      });
    } catch (err) {
      if (err) {
        const error = err as Error;
        console.error(error.message);
      }
    }

    if (msg.length > 0) {
      console.error(msg);
      throw new Error(msg);
    }

    const response = raw as IMyCmeResponse;

    const result: IMyCmeModel = {
      completed: response.completed || 0,
      creditBreakdown: (response.creditbreakdown || [])
        .filter(Boolean)
        .map(c => ({
          creditType: c.credittype || "",
          credits: c.credits || 0
        })),
      inProgress: response.inprogress || 0,
      totalCredits: response.totalcredits || 0
    };

    return result;
  }
}
